export function CustomToggle({ checked, onCheckedChange }: { checked: boolean; onCheckedChange: (checked: boolean) => void }) {
    return (
        <button
            onClick={() => onCheckedChange(!checked)}
            className={`w-10 h-6 flex items-center rounded-full p-1 transition-colors ${checked ? "bg-blue-500" : "bg-gray-200"
                }`}
        >
            <div
                className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-transform ${checked ? "translate-x-4" : "translate-x-0"
                    }`}
            ></div>
        </button>
    );
}